exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-recipe-template-tsx": () => import("./../../../src/templates/recipe-template.tsx" /* webpackChunkName: "component---src-templates-recipe-template-tsx" */)
}

